'use client';

import React, { useMemo, type ReactElement } from 'react';
import { usePathname } from 'next/navigation';
import { type TBrows } from '@/common/types/analytics.type';
import { selectCartItems, useCartStore } from '@/store/use-cart.store';
import classNames from 'classnames';
import AnalyticsWrapper from '@/common/components/analytics-wrapper';
import Button from '@/common/components/button';
import { calculateCartTotalCount } from '@/common/utils/cart-count.utility';
import { createQueryStringUtility } from '@/common/utils/create-query-string.utility';
import CartIcon from '~/public/assets/images/svg/cart.svg';

interface Props {
  id: keyof TBrows;
  iconClassName?: string;
}

export default function CartWidgetV2({
  id,
  iconClassName,
}: Props): ReactElement {
  const cartItems = useCartStore(selectCartItems);
  const vendorSlug = usePathname().split('/')[1];

  const count = useMemo(() => {
    return calculateCartTotalCount(cartItems);
  }, [cartItems]);

  return (
    <div className="relative h-12 w-[50px] shrink-0">
      <div className="absolute bottom-0 left-0 h-11 w-11">
        <AnalyticsWrapper analytics={[id]}>
          <Button
            type="link"
            className="
              flex
              !h-11
              !w-11
              items-center
              justify-center
              !rounded-[10px]
              !bg-[#EDECEB]
              !p-0
            "
            link={`/cart${createQueryStringUtility({
              from: '/' + vendorSlug,
            })}`}
            id={id}
            aria-label="سبد خرید"
          >
            <CartIcon
              className={classNames('h-5 w-5 text-[#191308]', iconClassName)}
              aria-hidden="true"
            />
          </Button>
        </AnalyticsWrapper>
      </div>

      {count > 0 && (
        <span
          className="
            absolute
            right-0
            top-0
            z-50
            flex
            h-4
            min-w-4
            items-center
            justify-center
            rounded-[5px]
            bg-[#E8453C]
            px-[3px]
            text-[8px]
            font-medium
            leading-none
            text-white
          "
        >
          {count}
        </span>
      )}
    </div>
  );
}
